// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"
import { tableMixins } from "@/app/mixins/utils/table-mixins.js"

// Components
const MemberTableComponent = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "member-table-component"*/ "@/app/views/main-view/social-club/components/member-table-component/member-table-component.vue"
	)

// Store
import store from "@/app/stores/store"

// Services
import ClubService from "@/app/services/main/club/club-service.js"

// Third Party libraries
import * as $ from "jquery"

// Constants
import { STATUS_CODES } from "@/app/constants/status-constants"

export default {
	name: "ModalSocialAddMembers",
	components: {
		MemberTableComponent,
	},
	mixins: [toastMessageMixins, tableMixins],
	data() {
		return {
			isAPILoading: false,
			searchMember: "",
			membersThatAreNotActive: [],
			isGetMembersLoading: false,
		}
	},
	beforeDestroy() {
		this.closeModal()
	},
	methods: {
		openModal() {
			$(this.$refs.addMembersModal).modal("show")
			this.searchMember = ""
			this.columnsFilter = {}
			this.getTableContent()
		},
		closeModal() {
			$(this.$refs.addMembersModal).modal("hide")
		},
		addMember(customerId) {
			const { getActiveGroup } = store.getters

			const reqBody = {
				customerIds: [customerId],
			}

			this.isAPILoading = true

			ClubService.addMemberToGroup(getActiveGroup.id, reqBody)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.isAPILoading = false

						this.$emit("updateAdminManagement")

						this.showCustomSuccessToast(null, "Successfully added member.")

						this.getTableContent(this.page, this.limit, this.sortBy, this.desc)
					} else {
						this.showCustomErrorToast(res.data.errors[0].message, null, true)

						this.isAPILoading = false
					}
				})
				.catch(() => {
					this.isAPILoading = false

					this.showCustomErrorToast(res.data.errors[0].message, null, true)
				})
		},
		hasMemberChecked(state) {
			this.hasMemberSelected = state
		},
		getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
			page = fromFilter ? 1 : this.page
			this.getMembersList({ page: this.page, limit: this.limit, sortBy: this.sortBy, desc: this.desc })
		},
		getMembersList(queryParams) {
			const groupId = this.$store.getters.getActiveGroup.id

			this.isGetMembersLoading = true

			queryParams["f_mStatus"] = "INACTIVE"

			if (this.columnsFilter) {
				if (this.columnsFilter.f_name) {
					queryParams["f_name"] = this.columnsFilter.f_name
				}
			}

			ClubService.getGroupMembers(groupId, queryParams)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.tableContent = {
							tableData: res.data.data,
							paginationData: res.data.pagination,
						}

						this.isGetMembersLoading = false
					} else {
						this.showCustomErrorToast(res.data.errors[0].message, null, true)
						this.isGetMembersLoading = false
					}
				})
				.catch(() => {
					this.isGetMembersLoading = false
					this.showGenericErrorToast()
				})
		},
	},
}
